export const mutations = {
    setGrupoFinanceiro(state, data) {
        state.grupoFinanceiro = data
    },
    setGruposFinanceiro(state, data) {
        state.gruposFinanceiro = data
    },
    addGrupoFinanceiro(state, data){
        state.gruposFinanceiro.push(data)
    },
    removeGrupoFinanceiro(state, data){
        let index = state.gruposFinanceiro.map(x => x.id).indexOf(data.id);
        state.gruposFinanceiro.splice(index, 1)
    },
    setModalCadastroGrupoFinanceiro(state, status) {
        state.modalCadastroGrupoFinanceiro = status
    },
    setModalExcluirGrupoFinanceiro(state, status) {
        state.modalExcluirGrupoFinanceiro = status
    },
    
}

export default {}